import Vue from 'vue';

export const assignmentDetailsService = {
  async retrieveAssignment(referenceNumber) {
    return Vue.axios.get(`/assignments/${referenceNumber}`).then(response => response.data);
  },
  async retrieveAssignmentForPdf(referenceNumber) {
    return Vue.axios.get(`/assignments/pdf/${referenceNumber}`).then(response => response.data);
  },
  async retrieveAssignmentTimeSheets(referenceNumber, sortOrder, pagination) {
    return Vue.axios
      .get(`/assignments/${referenceNumber}/time-sheets`, {
        params: {
          ...sortOrder,
          ...pagination
        }
      })
      .then(response => response.data);
  },
  async retrieveTimeSheetsRecordCount(referenceNumber) {
    return Vue.axios
      .get(`/assignments/${referenceNumber}/time-sheets-count`)
      .then(response => response.data);
  },

  async retrieveAssignmentExpenses(referenceNumber, sortOrder, pagination) {
    return Vue.axios
      .get(`/assignments/${referenceNumber}/expenses`, {
        params: {
          ...sortOrder,
          ...pagination
        }
      })
      .then(response => response.data);
  },
  async retrieveExpensesRecordCount(referenceNumber) {
    return Vue.axios
      .get(`/assignments/${referenceNumber}/expenses-count`)
      .then(response => response.data);
  },

  async retrieveAssignmentAttachments(referenceNumber) {
    return Vue.axios
      .get(`/assignments/${referenceNumber}/attachments`)
      .then(response => response.data);
  },
  async retrieveAssignmentHistories(referenceNumber) {
    return Vue.axios.get(`/assignments/${referenceNumber}/history`).then(response => response.data);
  },
  async doAssignmentAction(assignment, action) {
    let actionUrl = assignment.reference_number
      ? `/assignments/${assignment.reference_number}?action=${action}`
      : `/assignments/create?action=${action}`;
    return Vue.axios
      .post(actionUrl, {
        ...assignment
      })
      .then(response => response.data);
  },

  async createTimesheet(data) {
    return Vue.axios
      .post(`/assignments/${data.referenceNumber}/create-timesheet`, {
        ...data
      })
      .then(response => response.data);
  },

  async downloadAssignmentPdf(referenceNumber) {
    const response = await Vue.axios({
      url: `/assignments/${referenceNumber}/pdf`,
      method: 'GET',
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Assignemnt-${referenceNumber}.pdf`);
    document.body.appendChild(link);
    link.click();
  }
};
